import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { isSessionActive } from './SessionExpiry';

import { bankingRequiredRoutes, terminatedAllowedRoutes } from './Routes.js';
import {  groupPlans } from '../../utility/common/GlobalHSA';
import WrapperMain from '../../components/wrappers/WrapperMain.js';

function RouteClaim({
  component: Component,
  authType,
  isAdmin,
  missingPersonalInfo,
  missingPersonalBanking,
  missingCompanyInfo,
  missingCompanyBanking,

  bankingInfoWaived,
  
  pwResetRequired,
  onlineClaimEnabled,
  auditState,
  newEmployeeCheck,
  accountFrozen,
  isNonMemberAdmin,
  contractType,
  terminatedFlag,
  token,
  expiry,
  clockOffset,
  ...rest
}) {

  const currentLocation = useLocation();

  //catch missing required props
  if(!authType || !token || !expiry) {
    return (
      <Route
        {...rest}
        render={props => (<Redirect to={{ pathname: "/login", state: {from: props.location} }} /> )
        }
      />
    );
  }

  //hsa agreement check
  if(newEmployeeCheck === true && currentLocation.pathname !== '/hsa-agreement') {
    return (
      <Route
        {...rest}
        render={props => (<Redirect to={{ pathname: "/hsa-agreement", state: {from: props.location} }} /> )
        }
      />
    );
  }

  //missing personal info check
  else if(missingPersonalInfo ===  'Y' && currentLocation.pathname !== '/employee' && newEmployeeCheck !== true) {

    return (
      <Route
        {...rest}
        render={props => (<Redirect to={{ pathname: "/employee", state: {from: props.location} }} /> )
        }
      />
    );
  }

  //missing personal banking check
  else if(missingPersonalBanking ===  'Y' && missingPersonalInfo !==  'Y' && currentLocation.pathname !== '/banking-details' && newEmployeeCheck !== true && isNonMemberAdmin !== 'Y') {

    return (
      <Route
        {...rest}
        render={props => (<Redirect to={{ pathname: "/banking-details", state: {from: props.location} }} /> )
        }
      />
    );
  }
  //missing company info check
  else if(missingCompanyInfo === 'Y' && missingPersonalBanking !==  'Y' && missingPersonalInfo !==  'Y' && isAdmin ===  'Y' && currentLocation.pathname !== '/employer' && newEmployeeCheck !== true) {

    return (
      <Route
        {...rest}
        render={props => (<Redirect to={{ pathname: "/employer", state: {from: props.location} }} /> )
        }
      />
    );
  }
  //missing company info check
  else if( missingCompanyBanking ===  'Y' && bankingInfoWaived != 'Y' && groupPlans.includes(contractType) && missingCompanyInfo !== 'Y' && missingPersonalBanking !==  'Y' && missingPersonalInfo !==  'Y' && isAdmin ===  'Y' && newEmployeeCheck !== true) {

    return (
      <Route
        {...rest}
        render={props => (<Redirect to={{ pathname: "/business-banking", state: {from: props.location} }} /> )
        }
      />
    );
  }

  //ensure claiming is enabled
  else if(onlineClaimEnabled !== 'Y' || (parseInt(auditState) > 0 && currentLocation.pathname !== '/claims/success')) {
    return (
      <Route
        {...rest}
        render={props => (<Redirect to={{ pathname: "/", state: {from: props.location} }} /> )
        }
      />
    );
  }


  //check expiry
  //check reducer store and local token values
  const validToken = (token === localStorage.getItem('token'))? true : false;
  const validDate = isSessionActive(expiry, clockOffset);

  return(
        <Route
          {...rest}
          render={props =>
              (authType === 'EMPLOYEE' && validToken && validDate) ?
              (<React.Suspense fallback={<WrapperMain inSuspense={true}/>}>
                <Component {...props} />
              </React.Suspense>) :
              (<Redirect to={{ pathname: "/logout", state: {from: props.location} }} /> )
          }
        />
  );
}

export default RouteClaim;
